import React from 'react';
import { CtaButton } from './CtaButton';
export function FinalCta() {
  return <section className="w-full bg-ink px-5 py-20 sm:py-24" data-id="element-93" data-mp="vfftwlftpyqe">
      <div className="mx-auto max-w-2xl text-center" data-id="element-94" data-mp="vh0pmedvjnpu">
        <h2 className="font-display text-[1.75rem] font-black leading-tight tracking-tight text-white sm:text-[2.4rem]" data-id="element-95" data-mp="19fgxi8nh3k9k">
          Ready to Get Your Time Back?
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-white/65 sm:text-base" data-id="element-96" data-mp="1jd535tmmac6i">
          Join thousands of teachers who traded hours of prep for a curriculum
          that&apos;s ready when they are.
        </p>

        <CtaButton className="mt-8" label="Get the Physics & Chemistry Ready Pack — $27" data-id="element-97" data-mp="1t37ttn69ne1o" />

        <p className="mt-6 text-[11px] font-semibold text-white/50 sm:text-xs" data-id="element-98" data-mp="1o569kyx3t8om">
          Instant Access · 30-Day &ldquo;Keep Everything&rdquo; Guarantee ·
          One-Time Payment
        </p>
      </div>
    </section>;
}